import PropTypes from "prop-types";
import styles from "./SelectCompany.module.css";
import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import store from "../../Store/Store";

const SwitchCompany = ({
  onclose,
  isVisible,
  onclosepopup,
  className = "",
}) => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // Store filtered companies
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedCompany_id, setSelectedCompany_id] = useState("");
  const [companyFetched, setCompanyFetched] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // State for search input
  const [userFlow,setUserFlow]=useState("")

  useEffect(() => {
    setSelectedCompany(store.companyName);
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_cupi_companies`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: {},
    };

    axios
      .request(payload)
      .then((res) => {
        setData(res.data.data);
        setCompanyFetched(true);
        setFilteredData(res.data.data); // Initialize filteredData with full list
      })
      .catch((err) => console.log(err));
  }, []);

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchTerm(query);

    // Filter data based on search input
    setFilteredData(
      data.filter((company) =>
        company.registered_company_name.toLowerCase().includes(query)
      )
    );
  };

  const handelProceed = () => {
    store.setCompanyName(selectedCompany);
    store.setCompId(selectedCompany_id);
    store.setUserType(userFlow);
    store.refresh ? store.setRefresh(false) : store.setRefresh(true);
    onclose();
  };

  if (!isVisible) return null;

  return (
    <button
      className={[styles.selectCompany, className].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className={styles.selectCompanyInner}>
        <div className={styles.selectCompanyParent}>
          <div className={styles.selectCompany1}>Select Brand</div>
          <button
            className={styles.xCircle}
            onClick={() => {
              onclose();
              onclosepopup();
            }}
          >
            <img className={styles.icon} alt="" src="/icon1.svg" />
          </button>
        </div>
      </div>

      {/* Search Bar */}
      <div className={styles.textFieldParent}>
        <div className={styles.textField}>
          <div className={styles.content}>
            <img
              className={styles.leadingIcon}
              alt=""
              src="/leadingicon4.svg"
            />
            <input
              className={styles.labelText}
              placeholder="Search Brand"
              type="text"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </div>

        {/* Filtered Company List */}
        {filteredData.length > 0 ? (
          filteredData.map((details, index) => (
            <button
              key={index}
              className={styles.groupParent}
              onClick={() => {
                setSelectedCompany(details.registered_company_name);
                setSelectedCompany_id(details.ledger_label);
                setUserFlow(details.company_flow)
              }}
            >
              {console.log("details", details)}
              {selectedCompany === details.registered_company_name ? (
                <img
                  className={styles.frameChild}
                  alt=""
                  src="/group-2442.svg"
                />
              ) : (
                <div className={styles.frameItem} />
              )}
              <div className={styles.sunshineinfotech}>
                {details.registered_company_name == "Escrow Stack Pvt Ltd"
                  ? "Wayne Enterprises Pvt Ltd"
                  : details.registered_company_name}
              </div>
            </button>
          ))
        ) : (
          <>
            {companyFetched && (
              <div className={styles.noResults}>No brands found</div>
            )}
          </>
        )}

        {/* Proceed Button */}
        <button className={styles.loadsButtons} onClick={handelProceed}>
          <img
            className={styles.boxArrowInDownIcon}
            alt=""
            src="/boxarrowindown11.svg"
          />
          <b className={styles.loads}>{`Proceed `}</b>
        </button>
      </div>
    </button>
  );
};

SwitchCompany.propTypes = {
  className: PropTypes.string,
};

export default SwitchCompany;
